import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'medsurf-design-content-process-spinner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './process-spinner.content.design.html',
    styleUrls: ['./process-spinner.content.design.scss'],
    standalone: false
})
export class ProcessSpinnerContentDesign {
  @Input() width = 2;
}
